import { render, staticRenderFns } from "./Sondaggio.vue?vue&type=template&id=c6295d9c&"
import script from "./Sondaggio.vue?vue&type=script&lang=js&"
export * from "./Sondaggio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports